import { Typography } from "@mui/material";
import { useTaxonomy } from "../../contexts/TaxonomyContext";
import { capitalizeWords } from "../../utils/functions";

export const TaxonomyPath = ({ taxonomyPath: propTaxonomyPath }) => {
  // Use taxonomy from context if a prop wasn't provided
  const { taxonomyPath: contextTaxonomyPath } = useTaxonomy();
  const path = propTaxonomyPath ?? contextTaxonomyPath;

  if (!path) return null;

  return <Typography variant="body1">{capitalizeWords(path)}</Typography>;
};
